import ListRow from "./ListRow";
import { sortCuratedLists } from "./watchlistFormat";

function SectionLabel({ children }) {
  return (
    <p className="mb-2 mt-6 text-[11px] font-semibold tracking-[0.14em] text-tertiary first:mt-0">
      {children}
    </p>
  );
}

export default function ListPanel({
  userLists,
  curatedLists,
  previews,
  selectedListId,
  activeListId,
  onSelect,
  onCreate,
  onManage,
}) {
  const rowState = (list) => {
    if (String(activeListId) === String(list.id)) return "active";
    if (list.id === selectedListId) return "selected";
    return "idle";
  };

  const hasUserLists = userLists.length > 0;
  const orderedCurated = sortCuratedLists(curatedLists);
  const activeList = [...userLists, ...orderedCurated].find((list) => String(activeListId) === String(list.id));

  return (
    <aside className="border-r border-gray-100">
      <div className="max-h-[calc(100vh-9rem)] overflow-y-auto px-5 py-4">
      <SectionLabel>MY LISTS</SectionLabel>
      {hasUserLists ? (
        userLists.map((list) => (
          <div
            key={list.id}
            id={activeList?.id === list.id ? "watchlist-guide-active-list" : undefined}
          >
            <ListRow
              list={list}
              state={rowState(list)}
              preview={previews[list.id]}
              onClick={() => onSelect(list.id)}
            />
          </div>
        ))
      ) : (
        <div>
          <p className="text-sm text-secondary">No personal watchlists yet</p>
          <button
            id="watchlist-guide-new-button"
            type="button"
            onClick={onCreate}
            className="mt-2 text-sm font-medium text-primaryColor"
          >
            + New
          </button>
        </div>
      )}

      <div id="watchlist-guide-curated-section" className="mt-6">
        <SectionLabel>QUSHi CURATED LISTS</SectionLabel>
        <p className="-mt-1 mb-2 text-xs text-secondary">Ready-made lists for market context</p>
        <div id="watchlist-guide-curated-items">
          {orderedCurated.map((list) => (
            <div
              key={list.id}
              id={activeList?.id === list.id ? "watchlist-guide-active-list" : undefined}
            >
              <ListRow
                list={list}
                state={rowState(list)}
                preview={previews[list.id]}
                onClick={() => onSelect(list.id)}
              />
            </div>
          ))}
        </div>
      </div>

      {hasUserLists && (
        <div className="mt-6 flex items-center justify-between border-t border-gray-100 pt-4">
          <button
            id="watchlist-guide-new-button"
            type="button"
            onClick={onCreate}
            className="text-sm font-medium text-primaryColor"
          >
            + New
          </button>
          <button
            type="button"
            onClick={onManage}
            className="text-sm font-medium text-secondary"
          >
            Manage
          </button>
        </div>
      )}
      </div>
    </aside>
  );
}
